export const apiErrorHandler = (error) => { 
    if (!error instanceof Error) {
        return { errorMessage:'não foi possível executar a api' } 
    }
    const { message = 'não foi possível executar a api' } = error?.response?.data; 
    return { errorMessage:message }
} 